import { render } from "./App.vue?vue&type=template&id=22024b1f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=22024b1f&lang=css"

import exportComponent from "/Users/macbook13dbs1/Documents/Vue/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__